var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { staticClass: "currency-editor" },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("FinanceManage.ForeignCurrency") } },
            [
              _c("el-input", {
                staticStyle: { width: "100px" },
                attrs: { size: "mini" },
                model: {
                  value: _vm.form.sourceAmount,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sourceAmount", $$v)
                  },
                  expression: "form.sourceAmount"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "60px" },
                  attrs: { size: "mini" },
                  on: { change: _vm.currencyChangeHandler },
                  model: {
                    value: _vm.form.sourceCurrency,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "sourceCurrency", $$v)
                    },
                    expression: "form.sourceCurrency"
                  }
                },
                _vm._l(_vm.ddlCurrencyCollection, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: {
                      label: item.sourceCurrency,
                      value: item.sourceCurrency
                    }
                  })
                }),
                1
              ),
              _c("el-input", {
                staticStyle: { width: "80px" },
                model: {
                  value: _vm.form.exchangeRate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "exchangeRate", $$v)
                  },
                  expression: "form.exchangeRate"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }